import { render, staticRenderFns } from "./GridPedidos.vue?vue&type=template&id=69a9b3af&"
import script from "./GridPedidos.vue?vue&type=script&lang=js&"
export * from "./GridPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports